export const isSafariBrowser = (): boolean => {
  const { userAgent } = navigator
  return userAgent.includes('Safari') && !userAgent.includes('Chrome')
}
